import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/MarketingTopBanner';

export const MARKETING_TOP_BANNER_GET_SUCCESS = `${rootActionPath}/GET${SUCCESS_SUFFIX}`;
export const MARKETING_TOP_BANNER_GET_FAILURE = `${rootActionPath}/GET${FAILURE_SUFFIX}`;
